import React, { Component } from "react";

export class Step5Marketing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketingServices: props.formData.marketingServices || [],
      businessWebsite: props.formData.businessWebsite || "",
      socialPlatforms: props.formData.socialPlatforms || [],
      monthlyBudget: props.formData.monthlyBudget || "",
      campaignDuration: props.formData.campaignDuration || "",
      targetLocation: props.formData.targetLocation || "",
      targetAudience: props.formData.targetAudience || "",
      goals: props.formData.goals || "",
      error: "",
    };
  }

  handleCheckbox = (e, field) => {
    const { value, checked } = e.target;

    let values = [...this.state[field]];

    if (checked) {
      values.push(value);
    } else {
      values = values.filter((item) => item !== value);
    }

    this.setState({
      [field]: values,
      error: "",
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    if (this.state.marketingServices.length === 0) {
      this.setState({
        error: "Please select at least one marketing service.",
      });
      return;
    }

    this.props.updateFormData({
      marketingServices: this.state.marketingServices,
      businessWebsite: this.state.businessWebsite,
      socialPlatforms: this.state.socialPlatforms,
      monthlyBudget: this.state.monthlyBudget,
      campaignDuration: this.state.campaignDuration,
      targetLocation: this.state.targetLocation,
      targetAudience: this.state.targetAudience,
      goals: this.state.goals,
    });

    this.props.nextStep();
  };

  render() {
    const marketingServices = [
      "SEO",
      "Google Ads",
      "Facebook Ads",
      "Instagram Marketing",
      "Social Media Management",
      "Content Marketing",
      "Email Marketing",
      "YouTube Marketing",
      "WhatsApp Marketing",
      "Branding",
    ];

    const socialPlatforms = [
      "Facebook",
      "Instagram",
      "LinkedIn",
      "YouTube",
      "Twitter (X)",
      "Pinterest",
    ];

    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 5 : Digital Marketing Requirements
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Marketing Services */}
              <div className="col-12 mb-4">
                <label className="form-label fw-bold">
                  Select Required Services *
                </label>

                <div className="row">
                  {marketingServices.map((service, index) => (
                    <div className="col-md-4 mb-2" key={index}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`service${index}`}
                          value={service}
                          checked={this.state.marketingServices.includes(service)}
                          onChange={(e) =>
                            this.handleCheckbox(e, "marketingServices")
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`service${index}`}
                        >
                          {service}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Website */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Business Website
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="businessWebsite"
                  placeholder="https://example.com"
                  value={this.state.businessWebsite}
                  onChange={this.handleChange}
                />
              </div>

              {/* Campaign Duration */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Campaign Duration
                </label>

                <select
                  className="form-select"
                  name="campaignDuration"
                  value={this.state.campaignDuration}
                  onChange={this.handleChange}
                >
                  <option value="">Select Duration</option>
                  <option>1 Month</option>
                  <option>3 Months</option>
                  <option>6 Months</option>
                  <option>12 Months</option>
                </select>
              </div>

              {/* Budget */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Monthly Marketing Budget
                </label>

                <select
                  className="form-select"
                  name="monthlyBudget"
                  value={this.state.monthlyBudget}
                  onChange={this.handleChange}
                >
                  <option value="">Select Budget</option>
                  <option>₹5,000 - ₹10,000</option>
                  <option>₹10,000 - ₹25,000</option>
                  <option>₹25,000 - ₹50,000</option>
                  <option>₹50,000+</option>
                </select>
              </div>

              {/* Location */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Target Location
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="targetLocation"
                  placeholder="India, Pune, Mumbai..."
                  value={this.state.targetLocation}
                  onChange={this.handleChange}
                />
              </div>

              {/* Audience */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Target Audience
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="targetAudience"
                  placeholder="Students, Women, Business Owners..."
                  value={this.state.targetAudience}
                  onChange={this.handleChange}
                />
              </div>

              {/* Social Platforms */}
              <div className="col-12 mb-4">
                <label className="form-label fw-bold">
                  Social Media Platforms
                </label>

                <div className="row">
                  {socialPlatforms.map((platform, index) => (
                    <div className="col-md-4 mb-2" key={index}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`platform${index}`}
                          value={platform}
                          checked={this.state.socialPlatforms.includes(platform)}
                          onChange={(e) =>
                            this.handleCheckbox(e, "socialPlatforms")
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`platform${index}`}
                        >
                          {platform}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Goals */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  Marketing Goals
                </label>

                <textarea
                  rows="4"
                  className="form-control"
                  name="goals"
                  placeholder="Increase sales, generate leads, improve brand awareness..."
                  value={this.state.goals}
                  onChange={this.handleChange}
                />
              </div>

            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Step5Marketing;